export const initialState = {
  accountId: '',
  assetType: '',
  amount: '',
  lowFeeAccountBalance: false,
};
